/**
 * @file index.tsx
 *
 * @fileoverview Shows FAQ view.
 */

import React, { useContext } from 'react';
import { OrganizationFAQWidgetEmpty } from '~/jobiqo/components/Organization/Widgets/FAQ/Empty';
import OrganizationFAQWidgetView from '~/jobiqo/components/Organization/Widgets/FAQ/View';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { isSectionHidden } from '~/jobiqo/utils/config';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export const FAQ_KEY = 'faq';

interface OrganizationFAQWidgetProps {
  /**
   * The current organization profile.
   */
  organization: OrganizationProfile;
}

const OrganizationFAQWidget = ({
  organization,
}: OrganizationFAQWidgetProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  const GROUP_FIELDS = ORGANIZATIONS.ORGANIZATION_PAGE_FIELDS[FAQ_KEY];

  if (isSectionHidden(GROUP_FIELDS, organization.hiddenFields)) {
    return null;
  }

  const userContext: UserContextInterface = useContext(UserContext);

  if (!organization.faq || organization.faq?.length === 0) {
    return userContext.user && organization.canEdit ? (
      <OrganizationFAQWidgetEmpty organization={organization} boxId={FAQ_KEY} />
    ) : null;
  } else {
    return (
      <OrganizationFAQWidgetView organization={organization} boxId={FAQ_KEY} />
    );
  }
};

export default OrganizationFAQWidget;
